import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import Dropdown from '../../components/react/Dropdown';
import TrailAnimation from './components/TrailAnimation';
import SuccessMessageAnimation from './components/SuccessMessageAnimation';
import { useSnowReportSignup } from './hooks/useSnowReportSignup';
import Svg from '../../components/react/Svg';

const SnowReportSignup = ({
  endpoint,
  title,
  copy,
  options,
  emailPlaceholder,
  dropdownOptions,
  termsCopy,
  buttonLabel,
  sortLabel,
  successMessage,
  successCopy,
  successLinkLabel,
  emailErrorMessage,
  countrySelectionErrorMessage,
  expressConsentErrorMessage
}) => {
  const optionsObject = JSON.parse(options);
  const countryOptions = JSON.parse(dropdownOptions);
  const {
    useFetchData,
    handleDropdownOptions,
    handleEmailValue,
    handleSelectedOptions,
    setExpressConsent,
    handleResetForm,
    isValidEmail,
    emailAddress,
    expressConsent,
    isFirstLoad,
    isValid,
    errorMessage,
    isSubmitButtonDisabled,
    dropdownErrorMessage,
    subscriptions,
    country
  } = useSnowReportSignup({
    endpoint,
    countrySelectionErrorMessage,
    dataTitle: title
  });

  return (
    <div className="snow-report-signup__inner">
      <div className="snow-report-signup__container">
        <TrailAnimation isValid={isValid}>
          <h2 className="snow-report-signup__title">{title}</h2>
          <div className="snow-report-signup__copy rtf">{parse(copy)}</div>
          <div className="snow-report-signup__options">
            {optionsObject.map((option, i) => {
              return (
                <label
                  key={i}
                  className="snow-report-signup__input"
                  htmlFor={option.value}
                >
                  <input
                    type="checkbox"
                    name="subscriptions"
                    id={option.value}
                    value={option.value}
                    onChange={() => handleSelectedOptions(option.value)}
                    checked={subscriptions.includes(option.value)}
                  />
                  <span className="snow-report-signup__checkmark"></span>
                  {option.label}
                </label>
              );
            })}
          </div>
        </TrailAnimation>
      </div>
      <div className="snow-report-signup__container">
        <TrailAnimation isValid={isValid} delay={250}>
          <div className="snow-report-signup__email-input">
            <input
              type="email"
              name="sign-up-report-email"
              id="sign-up-report-email"
              onChange={e => handleEmailValue(e.target.value)}
              value={emailAddress}
              className={
                !isValidEmail && !isFirstLoad
                  ? 'snow-report-signup__email-input--error'
                  : ''
              }
              required
            />
            <label
              className={
                emailAddress
                  ? 'snow-report-signup__label snow-report-signup__label--with-text'
                  : 'snow-report-signup__label'
              }
              htmlFor="sign-up-report-email"
            >
              {emailPlaceholder}
            </label>
            {!isValidEmail && !isFirstLoad ? (
              <p className="snow-report-signup__input-error-message">
                {emailErrorMessage}
              </p>
            ) : (
              ''
            )}
          </div>
          <div>
            <Dropdown
              label={sortLabel}
              name="search-sort-items"
              options={JSON.parse(dropdownOptions).options}
              onChange={handleDropdownOptions}
              errorMessage={dropdownErrorMessage && dropdownErrorMessage}
              initialOption={country}
            />
          </div>
          <div className="snow-report-signup__terms">
            <label className="snow-report-signup__input" htmlFor="terms-check">
              <input
                type="checkbox"
                name="terms-check"
                id="terms-check"
                onChange={() => setExpressConsent(!expressConsent)}
                checked={expressConsent && expressConsent}
              />
              <span className="snow-report-signup__checkmark"></span>
              {termsCopy}
            </label>
            {!expressConsent && !isFirstLoad ? (
              <p className="snow-report-signup__input-error-message">
                {expressConsentErrorMessage}
              </p>
            ) : (
              ''
            )}
          </div>
          <button
            type="submit"
            className="btn btn--secondary btn--outline"
            onClick={useFetchData}
            disabled={isSubmitButtonDisabled}
          >
            {buttonLabel}
          </button>
          {!isValid && (
            <p className="snow-report-signup__input-error-message">
              {errorMessage}
            </p>
          )}
        </TrailAnimation>
      </div>
      <div
        className={
          isValid
            ? 'snow-report-signup__container'
            : 'snow-report-signup__container snow-report-signup__container--zIndex'
        }
      >
        <SuccessMessageAnimation isValid={!isValid}>
          <div className="snow-report-signup__icon-container">
            <Svg
              name="check-icon-circle"
              className="snow-report-signup__svg"
              altText="success"
            />
          </div>
          <h2 className="snow-report-signup__success-title">
            {successMessage}
          </h2>
          <p className="snow-report-signup__success-copy">{successCopy}</p>
          <button
            className="snow-report-signup__link"
            onClick={() => handleResetForm(countryOptions)}
          >
            {successLinkLabel}
          </button>
        </SuccessMessageAnimation>
      </div>
    </div>
  );
};

SnowReportSignup.propTypes = {
  endpoint: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  options: PropTypes.string.isRequired,
  emailPlaceholder: PropTypes.string.isRequired,
  dropdownOptions: PropTypes.string.isRequired,
  sortLabel: PropTypes.string.isRequired,
  termsCopy: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  successMessage: PropTypes.string.isRequired,
  successCopy: PropTypes.string.isRequired,
  successLinkLabel: PropTypes.string.isRequired,
  emailErrorMessage: PropTypes.string.isRequired,
  countrySelectionErrorMessage: PropTypes.string.isRequired,
  expressConsentErrorMessage: PropTypes.string.isRequired
};

export default SnowReportSignup;
